<template>
  <div>
    <!-- Invoice Totals -->
    <totals></totals>

    <!-- All Invoices -->
    <div class="w3-row">
      <div class="w3-col">
        <div class="w3-card w3-margin-top">
          <div class="w3-row w3-margin-bottom">
            <template v-if="state.admin.global.invoices.list.length > 0">
              <header class="dark">
                <h5>All Invoices</h5>
              </header>

              <invoices-grid></invoices-grid>
            </template>
            <template v-else>
              <div class="w3-container">
                <p>No Invoices Yet</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '@/dataStore';
import totals from '../molecules/totals.vue';
import invoicesGrid from '../organisms/invoicesGrid.vue';

export default {
  name: "invoices",
  data() {
    return {
      state: dataStore.state
    };
  },
  components: {
    'totals': totals,
    'invoices-grid': invoicesGrid
  },
};
</script>

<style scoped>
.invoiceRow {cursor:pointer}
.invoiceRow td {padding:0px 8px !important;}
</style>



// WEBPACK FOOTER //
// src/system/templates/invoices.vue